module.exports = __webpack_public_path__ + "media/about/CardsPreview-b9643239.jpg";